import { memo, useCallback, useMemo, useState } from "react";
import { CartUIContext, CartUIContextType } from "./cart-ui-context";

interface CartUIProviderProps {
  children: React.ReactNode;
}

export const CartUIProvider = memo(function CartUIProvider({
  children,
}: CartUIProviderProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const openDrawer = useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  const contextValue: CartUIContextType = useMemo(
    () => ({ isDrawerOpen, openDrawer, closeDrawer }),
    [isDrawerOpen, openDrawer, closeDrawer],
  );

  return (
    <CartUIContext.Provider value={contextValue}>
      {children}
    </CartUIContext.Provider>
  );
});
